<template>
    <li>
        <div v-for="(its, index) in treeData" :key="index">
          <div v-if="its.name">
            <span  v-bind:class="{'level1 ': true,
                                  'button': true,
                                  'switch':true,
                                  'noline_open': treeData.children && treeData.isExpand,
                                  'noline_close': treeData.children && !treeData.isExpand,
                                  'center_docu':!treeData.children && !treeData.isLastNode,
                                  'bottom_docu':!treeData.children && treeData.isLastNode}"
                  @click="changeExpand(treeData)">
            </span>
            <a class="level1"
              v-bind:class="{'level1 ': true,'curSelectedNode': treeData.isSelected}"
              @click="selectNode(its)">
                <!-- <span v-bind:class="{'ico_open': treeData.children,
                                        'ico_docu':treeData.children == null || treeData.children.length == 0,
                                        'button':true}">
                </span> -->
                <span class="org-icon">
                    <zx-icon :type="treeData.level < 3 ? 'icon-jigou' : 'icon-organize'"></zx-icon>
                </span>
                <span class="node_name" id="treeDemo_9_span">{{its.name}}</span>
            </a>

            <ul v-if="its.children && its.isExpand"
                v-bind:class="{'line': its.isLastNode == false,
                                'level1':true}"
                style="display:block">
                <z-scene-chooser-item v-for="item in its.children" :treeData="item" :key="item.data.id" @selectNode="onSelectNode"></z-scene-chooser-item>
            </ul>
          </div>
        </div>
    </li>

</template>

<script>
    
    export default {
        name: "ZSceneChooserItem",
        components: {
          
        },
        data: function () {
            return {}
        },
        // watch: {
        //   treeData(val) {
        //     this.treeData = val
        //   }
        // },
        props: ['treeData'],
        methods: {
            changeExpand(node) {
                node.isExpand = !node.isExpand;
            },
            selectNode(node) {
                this.$emit('selectNode', node);
            },
            onSelectNode(node) {
                this.$emit('selectNode', node);
            }
        },
    }
</script>
